export default __webpack_public_path__ + "static/media/slide28.6ef5c1b6.png";